import React from 'react';

import { ListWithTitle } from '../components/ListWithTitle';
import { Paragraph } from '../components/Paragraph';
import { Subtitle } from '../components/Subtitle';

export const PurposeOfCollectionAndUseOfPersonalData = () => {
  return (
    <>
      <Subtitle>Purpose of Collection and Use of Personal Data</Subtitle>
      <Paragraph>
        In the course of using the Site, you may disclose or be asked to provide
        personal information and/or data. In order to have the benefit of and
        enjoy various services offered by the Site, it may be necessary for you
        to provide Glints with your personal information and/or data. Although
        you are not obliged to provide the information and/or data as requested
        on the Site, Glints will not be able to render certain services on the
        Site in the event that you fail to do so.
      </Paragraph>
      <ListWithTitle
        title={
          <>
            Glints purposes for collecting and using the information and data on
            the Site include but are not limited to the following:
          </>
        }
        list={[
          <>for the daily operation of the services provided to you;</>,
          <>
            to assist you to find appropriate employment with Employers and to
            assist Employers to assess the suitability of candidates for a job
            vacancy for a wide spectrum of jobs and industries;
          </>,
          <>
            to provide you with various services offered by the Site and
            newsletters, information on job openings and promotional and
            marketing materials (for further details, please refer to section
            headed “Subscription of Newsletter/Promotional Materials/Marketing
            Materials” below);
          </>,
          <>
            to handle and follow up on enquiries, requests and complaints from
            you;
          </>,
          <>
            to contact you regarding administrative notices and communications
            relevant to your use of the Site and to respond to your inquiries or
            requests;
          </>,
          <>
            to assist Glints with developments for future marketing and
            promoting purposes or other internal purposes;
          </>,
          <>
            to verify your identity in posted advertisements, materials,
            representations, messages, views or comments or such other
            information (collectively “Information“) on the Site;
          </>,
          <>to identify who viewed the Information posted on the Site;</>,
          <>
            to allow you to enjoy your benefits as members of the Site by
            enrolling for special events and promotions hosted by Glints and/or
            its affiliates and/or partner companies;
          </>,
          <>
            to facilitate Glints and/or its affiliates to use your personal data
            for the purposes relating to the provision of services offered by
            Glints and marketing services and/or special events of Glints and/or
            its affiliates;
          </>,
          <>
            to obtain statistics to analyze usage of the Site in order to help
            its further development; and
          </>,
          <>
            for purposes other than the above mentioned which are related to
            Glints and/or its affiliates’ provision of their product and/or
            services.
          </>,
        ]}
      />
      <Paragraph>
        Before using the Site or disclosing any information or data on the Site,
        if you are a minor in the jurisdiction in which you reside, you should
        seek prior consent from a person with parental responsibility for you,
        e.g. parent or guardian, who may contact the responsible Data Protection
        Officer whose contact details are set out under the section headed
        “Enquiries”.
      </Paragraph>
      <Paragraph>
        Glints strives to only collect personal data which are necessary and
        adequate but not excessive in relation to the purposes set out
        hereinabove.
      </Paragraph>
      <Paragraph>
        If Glints requires the use of your personal data for a purpose other
        than those set out hereinabove, we will request your prescribed consent
        to the same. If you are a minor, the prescribed consent should be given
        by your parent or guardian.
      </Paragraph>
    </>
  );
};
